<div class="container">

  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item" aria-current="page">
        <a class=" text-decoration-none">
          <fa-icon icon="newspaper"></fa-icon>
          <span jhiTranslate="global.menu.medias">institutions</span>
        </a>
      </li>
    </ol>
  </nav>

  <h4 class="text-primary">Das Angebot von sexcare – Sexualbegleitung stösst in den Medien auf ein reges Interesse</h4>

  <div class="row mt-4">
    <div class="col-lg-8 mb-3">
      <ngb-carousel [showNavigationIndicators]="showNavigationIndicators">
        <ng-template ngbSlide>
          <a href="https://www.srf.ch/play/tv/popupvideoplayer?starttime=0&urn=urn%3Asrf%3Avideo%3Ac4659015-1d6a-44c6-a89a-96fde5fde18b" target="_blank"><img
            src="/../../../content/images/media_video_2.png" class="d-block w-100"></a>
          <!--          <div class="picsum-img-wrapper">-->
          <!--            <div class="ratio ratio-16x9">-->
          <!--              <iframe-->
          <!--                src="https://www.srf.ch/play/tv/popupvideoplayer?starttime=0&urn=urn%3Asrf%3Avideo%3Ac4659015-1d6a-44c6-a89a-96fde5fde18b"-->
          <!--                title="the session video"></iframe>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="carousel-caption">
            <h3 class="text-primary">10 vor 10</h3>
          </div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="picsum-img-wrapper">
            <a href="https://www.srf.ch/play/tv/popupvideoplayer?startTime=3.991&urn=urn%3Asrf%3Avideo%3Abfb1191f-d445-4013-ba0d-ee897580fc62" target="_blank"><img
              src="/../../../content/images/media_video_1.png" class="d-block w-100"></a>
            <!--            <div class="ratio ratio-16x9">-->
            <!--              <iframe-->
            <!--                src="https://www.srf.ch/play/tv/popupvideoplayer?startTime=3.991&urn=urn%3Asrf%3Avideo%3Abfb1191f-d445-4013-ba0d-ee897580fc62"-->
            <!--                title="the session video"></iframe>-->
            <!--            </div>-->
          </div>
          <div class="carousel-caption">
            <h3 class="text-primary">Aeschbacher</h3>
          </div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="picsum-img-wrapper">
            <!--            <div class="ratio ratio-16x9">-->
            <!--              <iframe src="https://player.vimeo.com/video/167277975" title="the session video"></iframe>-->x
            <!--            </div>-->
            <a href="https://player.vimeo.com/video/167277975" target="_blank"><img
              src="/../../../content/images/media_video_3.png" class="d-block w-100"></a>
          </div>
          <div class="carousel-caption">
            <h3 class="text-primary">Südkurier Online</h3>
          </div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="picsum-img-wrapper">
            <a href="https://www.youtube.com/embed/fhrb63v6h4U?si=jhnUspBhvEvc1jv3" target="_blank"><img
              src="/../../../content/images/media_video_4.png" class="d-block w-100"></a>
            <!--            <div class="ratio ratio-16x9">-->
            <!--              <iframe src="https://www.youtube.com/embed/fhrb63v6h4U?si=jhnUspBhvEvc1jv3"-->
            <!--                      title="YouTube video player"></iframe>-->
            <!--            </div>-->
          </div>
          <div class="carousel-caption">
            <h3 class="text-primary">JOI ZONE</h3>
          </div>
        </ng-template>
      </ngb-carousel>
    </div>
    <div class="col-lg-4">
      <div class="border rounded p-3 mb-4" style="background-color: #eaeaea;">
        <h6 class="">Radio Sendungen</h6>
        <div class="mb-1">
          <a class="text-decoration-none"
             href="https://open.spotify.com/episode/6VBxdTxkM0gypZ3ppxSMLy?si=9EuQmF5nSGWEQmNjyTkIOQ&amp%3Bdl_branch=1&nd=1&dlsi=37641082e3ce4fa0"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="globe"></fa-icon></span>
            Podcast Kulturzyklus Kontrast FH OST, Januar 2022
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none"
             href="https://www.fm1today.ch/schweiz/mit-koerper-und-seele-im-einsatz-134983173" target="_blank">
            <span><fa-icon class="text-secondary" icon="globe"></fa-icon></span>
            FM1Today-Gott und d’Wält, Januar 2017
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none"
             href="https://www.srf.ch/news/regional/bern-freiburg-wallis/bei-isabelle-koelbl-duerfen-behinderte-ganz-mann-sein#main-comments"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="globe"></fa-icon></span>
            SRF1 Sonntagsgast März 2016
          </a>
        </div>


        <h6 class=" mt-4">Print Highlights</h6>
        <div>
          <a class="text-decoration-none" href="../../../content/docs/VN-Sexualassistenz-wird-legalisiert.pdf"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="file-pdf"></fa-icon></span>
            Vorarlberger Nachrichten, Sexualassistenz wird legalisiert
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none" class="text-decoration-none font-weight-light"
             href="../../../content/docs/Golden-Generation-Artikel.pdf" target="_blank">
            <span><fa-icon class="text-secondary" icon="file-pdf"></fa-icon></span>
            Golden Generation Mai 2022
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none" href="../../../content/docs/Muskelgesellschaft.pdf" target="_blank">
            <span><fa-icon class="text-secondary" icon="file-pdf"></fa-icon></span>
            Muskelgesellschaft Dez. 2019
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none" href="../../../content/docs/Aarauer-Nachrichten.pdf" target="_blank">
            <span><fa-icon class="text-secondary" icon="file-pdf"></fa-icon></span>
            Aarauer Nachrichten Apr. 2019
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none"
             href="https://www.luzernerzeitung.ch/zentralschweiz/zug/eine-sexarbeiterin-mit-besonderem-ziel-ld.1102543"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="globe"></fa-icon></span>
            Luzerner Zeitung März 2019
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none"
             href="https://www.bern-ost.ch/Ich-muss-fuer-die-Maenner-meine-Hand-ins-Feuer-legen-koennen-591003"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="globe"></fa-icon></span>
            Berner Zeitung Okt. 2018
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none" href="../../../content/docs/Suedkurier.pdf" target="_blank">
            <span><fa-icon class="text-secondary" icon="file-pdf"></fa-icon></span>
            Südkurier vom Nov. 2016
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none" href="../../../content/docs/Ostschweiz-am-Sonntag.pdf" target="_blank">
            <span><fa-icon class="text-secondary" icon="file-pdf"></fa-icon></span>
            Ostschweiz am Sonntag, Okt. 2016
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none" href="../../../content/docs/Il-Caffe.pdf" target="_blank">
            <span><fa-icon class="text-secondary" icon="file-pdf"></fa-icon></span>
            Il Caffe, Nov. 2015
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none"
             href="https://www.blick.ch/schweiz/pro-infirmis-soll-zahlen-ich-moechte-einmal-im-leben-sex-haben-id4404043.html"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="globe"></fa-icon></span>
            BLICK, Nov. 2015
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none"
             href="https://www.blick.ch/people-tv/schweiz/isabelle-koelbl-macht-behinderte-gluecklich-sex-gegen-geld-aber-ich-bin-keine-hure-id4260563.html#community_article_comments_default_4260563"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="globe"></fa-icon></span>
            BLICK, Okt. 2015
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none"
             href="https://www.tagesanzeiger.ch/die-cyber-puffmutter-377543604575#mostPopularComment"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="globe"></fa-icon></span>
            Tagi, März 2015
          </a></div>
        <div class="mb-1">
          <a class="text-decoration-none"
             href="https://www.nzz.ch/zuerich/stadt-zuerich/alle-duerfen-sex-haben-ld.1032584"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="globe"></fa-icon></span>
            NZZ, Dez. 2014
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none" href="../../../content/docs/SchweizerIllustrierte-100-Bernerinnen.pdf"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="file-pdf"></fa-icon></span>
            Schweizer Illustrierte, Sept. 2014
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none" href="../../../content/docs/Berner-Landbote-Begegnungen.pdf" target="_blank">
            <span><fa-icon class="text-secondary" icon="file-pdf"></fa-icon></span>
            Berner Landbote, Juni 2014
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none" href="../../../content/docs/Sozial-Aktuell.pdf" target="_blank">
            <span><fa-icon class="text-secondary" icon="file-pdf"></fa-icon></span>
            SozialAktuell, Apr. 2014
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none"
             href="https://www.20min.ch/story/workshop-lehrt-frauen-sex-mit-behinderten-751330593364"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="globe"></fa-icon></span>
            20 Minuten, Apr. 2014
          </a>
        </div>
        <div class="mb-1">
          <a class="text-decoration-none"
             href="https://www.bernerzeitung.ch/sie-befriedigt-beduerfnisse-behinderter-maenner-191501836039"
             target="_blank">
            <span><fa-icon class="text-secondary" icon="globe"></fa-icon></span>
            BZ, Febr. 2014
          </a>
        </div>

        <div class="mt-3">
          <h6>Medienanfragen bitte an</h6>
        </div>
        <div class="align-items-center">
          <div class="w-25 h-25">
            <img
              src="/../../../content/images/ik_logo.png"
              alt=""
              class="about-img img-fluid rounded-circle"
            />
          </div>
          <p>
            Isabelle Kölbl, Geschäftsführerin
            <br>
            <a href="mailto:info@sexcare.ch">info&#64;sexcare&#46;ch</a>
          </p>
        </div>
      </div>
    </div>
  </div>
